module.exports = __webpack_public_path__ + "img/fullLogo.eec9d307.svg";